var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 10C3.141 10 0 13.14 0 17C0 17.552 0.447 18 1 18C1.553 18 2 17.552 2 17C2 14.243 4.243 12 7 12C9.757 12 12 14.243 12 17C12 17.552 12.447 18 13 18C13.553 18 14 17.552 14 17C14 13.14 10.859 10 7 10ZM5 4C5 5.103 5.897 6 7 6C8.103 6 9 5.103 9 4C9 2.897 8.103 2 7 2C5.897 2 5 2.897 5 4ZM3 4C3 1.794 4.794 0 7 0C9.206 0 11 1.794 11 4C11 6.206 9.206 8 7 8C4.794 8 3 6.206 3 4ZM19 4C19 4.55 18.55 5 18 5H17V6C17 6.55 16.55 7 16 7C15.45 7 15 6.55 15 6V5H14C13.45 5 13 4.55 13 4C13 3.45 13.45 3 14 3H15V2C15 1.45 15.45 1 16 1C16.55 1 17 1.45 17 2V3H18C18.55 3 19 3.45 19 4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPlus);
export default __webpack_public_path__ + "static/media/person-plus.07a370d6a076a0542f5bad7ea12224c6.svg";
export { ForwardRef as ReactComponent };